<!-- 物资信息 / 货主管理 -->
<template>
  <div>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad">
      <template slot="annexPath" slot-scope="{ row }">
        <template v-if="annexPathList(row.annexPath).length">
          <el-link
            v-for="(url, idx) in annexPathList(row.annexPath)"
            :key="idx"
            type="primary"
            :underline="false"
            style="margin-right: 8px"
            @click.native.prevent="openAnnex(url)"
          >
            附件{{ annexPathList(row.annexPath).length > 1 ? idx + 1 : '' }}
          </el-link>
        </template>
        <span v-else>—</span>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, uploadEndpoint } from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";
import validator from '@/util/validate.js'

export default {
  mixins: [crudMixins],
  data () {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      option: {
        ...this.$store.state.publicOption,
        labelWidth: 140,
        // 关闭列设置，避免本地缓存的列显隐不含新字段时把「修改人/修改时间」默认隐藏
        columnBtn: false,
        column: [
          {
            label: '货主名称',
            prop: 'deptName',
            maxlength: 40,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入货主名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '所属租户',
            prop: 'tenantId',
            type: 'tree',
            maxlength: 40,
            dicUrl: '/api/blade-system/tenant/select',
            addDisplay: false,
            editDisplay: false,
            props: {
              label: 'tenantName',
              value: 'tenantId',
            },
            rules: [
              {
                required: true,
                message: '请输入所属租户',
                trigger: 'click',
              },
            ],
          },
          {
            label: '货主全称',
            prop: 'fullName',
            maxlength: 40,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入货主全称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '统一社会信用代码',
            prop: 'creditCode',
            maxlength: 30,
            hide: false,
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
            overHidden: true,
            rules: [
              {
                required: true,
                message: '请输入统一社会信用代码',
                trigger: 'blur',
              },
              {
                required: false,
                validator: validator.checkSCC,
                trigger: 'blur',
              },
            ],
          },
          {
            label: '法人姓名',
            prop: 'legalPersonName',
            maxlength: 30,
            hide: false,
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: '法人身份证号',
            prop: 'legalPersonIdNo',
            maxlength: 18,
            hide: false,
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
            overHidden: true,
            rules: [
              {
                required: false,
                validator: validator.validateIdNo,
                trigger: 'blur',
              },
            ],
          },
          {
            label: '联系人',
            prop: 'contacts',
            maxlength: 20,
            hide: false,
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: '联系方式',
            prop: 'telephone',
            maxlength: 20,
            hide: false,
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
            overHidden: true,
            rules: [
              {
                required: false,
                validator: validator.notRequiredPhone,
                trigger: 'blur',
              },
            ],
          },
          {
            label: '邮箱',
            prop: 'email',
            maxlength: 50,
            hide: false,
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
            overHidden: true,
            rules: [
              {
                required: false,
                validator: validator.notRequiredEmail,
                trigger: 'blur',
              },
            ],
          },
          {
            label: '附件',
            prop: 'annexPath',
            type: 'upload',
            multiple: true,
            drag: true,
            action: uploadEndpoint,
            propsHttp: { res: 'data', url: 'link' },
            dataType: 'string',
            tip: '请上传标准格式文件, 最多可上传5个',
            limit: 5,
            span: 24,
            slot: true,
            hide: false,
            viewDisplay: true,
            addDisplay: true,
            editDisplay: true,
            minWidth: 120,
            overHidden: true,
          },
          {
            label: '货主编码',
            prop: 'id',
            maxlength: 20,
            search: false,
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
          },
          {
            label: '录入人',
            prop: 'createUserName',
            hide: false,
            showColumn: true,
            // 表单显隐由 beforeOpen 按 type 设置 display，勿仅用 editDisplay（会被 display 覆盖）
            display: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            search: false,
            minWidth: 100,
            overHidden: true,
            span: 12,
          },
          {
            label: '录入时间',
            prop: 'createTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            hide: false,
            showColumn: true,
            display: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            search: false,
            minWidth: 170,
            overHidden: true,
            span: 12,
          },
          {
            label: '修改人',
            prop: 'updateUserName',
            hide: true,
            showColumn: false,
            display: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            search: false,
            minWidth: 100,
            overHidden: true,
            span: 12,
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            hide: true,
            showColumn: false,
            display: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            search: false,
            minWidth: 170,
            overHidden: true,
            span: 12,
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            maxlength: 200,
            span: 24,
            minRows: 3,
            rules: [
              {
                required: false,
                message: '请输入备注',
                trigger: 'blur',
              },
            ],
            hide: true,
          },
        ],
      },
    }
  },
  methods: {
    /**
     * Avue：表单上 `display: true` 会压住 `editDisplay: false`，编辑里仍会画出审计字段。
     * 打开弹窗前按类型用 $set 设置 display，仅「详情」显示录入/修改信息，新增/编辑不显示。
     */
    beforeOpen (done, type) {
      const auditProps = new Set(['createUserName', 'createTime', 'updateUserName', 'updateTime'])
      this.option.column.forEach((col) => {
        if (auditProps.has(col.prop)) {
          this.$set(col, 'display', type === 'view')
        }
      })
      this.openType = type
      if (['edit', 'view'].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig.getDetail(this.form.id).then((res) => {
          this.form = res.data.data || res.data
          done()
        })
      } else {
        done()
      }
    },
    annexPathList (val) {
      if (val == null || val === '') return []
      return String(val)
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
    },
    openAnnex (url) {
      if (!url) return
      window.open(url, '_blank', 'noopener,noreferrer')
    },
  },
}
</script>
<style scoped lang="scss"></style>
